import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles.css'
import './platforms.css'
import './materials.css'
import './auth.css'
import './enhancements.css'
import './trend-enhancements.css'

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
